// eslint-disable-next-line no-shadow
export const focus = {
  inserted(el, { value }) {
    if (value || value === undefined) el.focus();
  }
};

export const test = false;



// WEBPACK FOOTER //
// ./src/utils/directives.js